import React, { useEffect, useState } from "react";
import { FaUsers } from "react-icons/fa";
import "./AdminDashboard.css";
// import StatsTable from "./StatsTable";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function AdminDashboard() {
  const SUMMARY_API = "https://node.aattumtpl.com/api/admin/eventreports/dec2025-womens-t20-summary";


  const navigate = useNavigate();

  const [teamCount, setTeamCount] = useState(0);
  const [individualCount, setIndividualCount] = useState(0);
  const [registrationCount, setRegistrationCount] = useState(0);
  const [registrationUserIds, setRegistrationUserIds] = useState([]);

  useEffect(() => {
    fetchSummary();
  }, []);

  const fetchSummary = async () => {
    const res = await axios.get(SUMMARY_API);
    setTeamCount(res.data.summary.teams);
    setIndividualCount(res.data.summary.individuals);
    setRegistrationCount(res.data.summary.registrations);
    setRegistrationUserIds(res.data.summary.registrationUserIds || []);
  };

  const [stats, setStats] = useState({
    totalTeams: 0,
    totalIndividuals: 0,
    totalRegistrations: 0,
  });

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const res = await fetch("https://node.aattumtpl.com/api/admin/reports/summary");
        const data = await res.json();

        if (data.success) {
          setStats({
            totalTeams: data.summary.teams,
            totalIndividuals: data.summary.individuals,
            totalRegistrations: data.summary.registrations,
          });
        }
      } catch (err) {
        console.error("Error fetching summary", err);
      }
    };

    fetchSummary();
  }, []);


  return (
    <div>
      {/* Navbar */}


      {/* Dashboard Content */}
      <main className="main-admin">
        <header className="header-admin">
          <h2>Admin Dashboard</h2>
          <p>
            Manage sports registrations, teams, individual players, and users efficiently. Use filters and reports to quickly gain insights and take action.
          </p>

        </header>

        {/* Stats Section */}
        <section className="stats-grid-admin">

          {/* Sports Card */}
          <div className="card-admin">
            <FaUsers className="icon-admin" />
            {/* <h2
              style={{
                fontWeight: "600",
                marginBottom: "20px",
                marginTop: "5px",
                fontSize: "20px",
                color: "#4e73df",
              }}
            >
              Women's T20 Event Report - DEC 2025
            </h2> */}

            {/* Total Registrations */}
            <h3
              onClick={() => navigate("/Dec2025_Womens_T20-report")}
              style={{ cursor: "pointer" }}
            >
              {registrationCount}
            </h3>
            <p>Total Women's T20 Event Registrations</p>

            <div className="sub-stats center-split">

              {/* Individual Count */}
              <div
                onClick={() => navigate("/Dec2025_Womens_T20-report?type=individual")}
                style={{ cursor: "pointer" }}
              >
                <h4>{individualCount}</h4>
                <p>Individual</p>
              </div>

              {/* Team Count */}
              <div
                onClick={() => navigate("/Dec2025_Womens_T20-report?type=team")}
                style={{ cursor: "pointer" }}
              >
                <h4>{teamCount}</h4>
                <p>Team</p>
              </div>

            </div>
          </div>

          {/* Users Card */}
          <div className="card-admin">
            <FaUsers className="icon-admin" />
            <h3
              onClick={() => navigate("/Men'sT20")}
              style={{ cursor: "pointer" }}>{stats.totalRegistrations}</h3>

            <p>Total Men's T20 Event Registrations</p>

            <div className="sub-stats center-split">
              <div
                onClick={() => navigate("/Men'sT20")}
                style={{ cursor: "pointer" }}
              >
                <h4>{stats.totalIndividuals}</h4>
                <p>Individual</p>
              </div>
              <div
                onClick={() => navigate("/Men'sT20")}
                style={{ cursor: "pointer" }}
              >
                <h4>{stats.totalTeams}</h4>
                <p>Team</p>
              </div>
            </div>
          </div>

        </section>

        <section className="mt-8">


        </section>

      </main>
    </div>
  );
}
